import React from 'react'
import styled from 'styled-components'
import ContentArea from '../components/ContentArea'
import SelectButton from '../components/SelectButton'

const YogaPage = () => {
    const HomeHeader = styled.h1`
    font-weight: 500;
    width: 70%;
    margin: 0 auto 53pt !important;
    text-align: center;
    font-size: 20pt;

    @media screen and (min-width: 768px) {
      margin-bottom: 3rem !important;
    }
  `
    return (
        <ContentArea transparent shadowless fullsize>
            <div>
                <div>
                    <HomeHeader>Mindful Movement Practices </HomeHeader>
                    <SelectButton
                        value="Mindful Standing Yoga"
                        link
                        linkto={`/yoga/video/standingyoga`}
                    />
                    <SelectButton
                        value="Mindful Chair Yoga"
                        link
                        linkto={`/yoga/video/chairyoga`}
                    />
                    <SelectButton
                        value="Mindful Qigong"
                        link
                        linkto={`/yoga/video/qigong`}
                    />
                </div>
            </div>

        </ContentArea>
    )
}

export default YogaPage
